import { render } from "./IconEnvelope.vue?vue&type=template&id=6d04ede9"
const script = {}
script.render = render

export default script